import { inputLabelClasses, outlinedInputClasses } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import { JSX, RefObject } from 'react';
import { useIntl } from 'react-intl';

import { HBSelect, HBSelectProps } from '../../../../HBSelect/HBSelect';
import { messages } from '../../messages';

type HBGridStatusProps = {
  statusProps?: Partial<HBSelectProps> & { show?: boolean };
  onChange?: (value: string | number, type: 'status' | 'search') => void;
  agGridRef: RefObject<AgGridReact> | undefined;
};

type SelectBoxOptionsType = HBSelectProps['menuItem'];

export function HBGridStatus(props: HBGridStatusProps): JSX.Element | null {
  const { statusProps, onChange } = props;
  const { formatMessage } = useIntl();
  const activeLocaleText = formatMessage(messages.active);
  const inActiveLocaleText = formatMessage(messages.inActive);
  const statusLocaleText = formatMessage(messages.status);

  if (statusProps?.show)
    return (
      <HBSelect
        onChange={(event) => {
          if (typeof event?.target?.value === 'number' || typeof event?.target?.value === 'string')
            onChange?.(event?.target?.value, 'status');
        }}
        menuItem={
          statusProps?.menuItem
            ? statusProps?.menuItem
            : ([
                { title: activeLocaleText, value: 1 },
                { title: inActiveLocaleText, value: 0 },
              ] as SelectBoxOptionsType)
        }
        placeholder={statusProps?.placeholder ?? statusLocaleText}
        label={statusProps?.label ?? statusLocaleText}
        sx={{
          height: 33,
          minWidth: 150,
          [`& .${inputLabelClasses.root}`]: {
            top: -4,
          },
          [`& .${outlinedInputClasses.root}`]: {
            height: 33,
          },
          [`& .${outlinedInputClasses.input}`]: {
            position: 'relative',
            top: -4,
          },
        }}
        size="small"
        {...statusProps}
      />
    );

  return null;
}
